<template>
  <div id="Solid"></div>
</template>

<script>
export default {
  name: "Solid",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
#solid {
  height: 20px;
  background: #f3f1f1;
}
</style>


// WEBPACK FOOTER //
// src/components/Solid/Solid.vue